import { SubnavigationBar } from '@vkontakte/vkui';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import { multiTariffsMobileTabsAnimation } from 'reactApp/appHelpers/featuresHelpers/features/multiTariffMobile';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { useCancelPreScrollAnimation } from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/hooks/useCancelPreScrollAnimation';
import styles from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/MultiTariffsListMobile.css';
import { ScrollableTabItem } from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/MultiTariffsTabsMobile/Scrollable/ScrollableTabItem';
import type { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

interface ScrollableTabsProps {
    tabOptions: {
        value: ETabsName;
        text: string;
    }[];
    activeTariffTab?: ETabsName;
    onChangeTab: (value: ETabsName) => void;
}

export function ScrollableTabs({ tabOptions, activeTariffTab, onChangeTab }: ScrollableTabsProps) {
    const { isLoaded } = useSelector(ProductsSelectors.getLifeCycleState);
    const { animationCancelled, cancelAnimation, onAnimationStart } = useCancelPreScrollAnimation();
    return (
        <SubnavigationBar
            onAnimationStart={onAnimationStart}
            className={classNames(styles.scrollable_tabs_root, {
                [styles.scrollable_tabs_animated_slider]: isLoaded && !animationCancelled && multiTariffsMobileTabsAnimation,
            })}
        >
            {tabOptions.map(({ value, text }) => {
                return (
                    <ScrollableTabItem
                        key={value}
                        text={text}
                        value={value}
                        activeTariffTab={activeTariffTab}
                        onClick={() => {
                            cancelAnimation();
                            onChangeTab(value);
                        }}
                    />
                );
            })}
        </SubnavigationBar>
    );
}
